import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const HuggingFaceAgent: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Hugging Face DeepSite Agent
        </Typography>
        {/* Ajoutez ici le contenu spécifique à l'agent Hugging Face */}
      </Box>
    </Container>
  );
};

export default HuggingFaceAgent; 